import React from 'react';
import { Container, Grid, Header } from 'semantic-ui-react';
import './style.css';

const speakersList = [
  {
    image: require('./images/Magri.png'),
    title: "Paolo Magri",
    subtitle: "Docente di Relazioni Internazionoli<br /> alla Bocconi<br />e Presidente del Comitato Scientifico<br />dell'ISPI"
  },
  {
    image: require('./images/Bortoli.png'),
    title: "Ferruccio de Bortoli",
    subtitle: "Presidente della Fondazione<br />Corriere della Sera"
  },
]

const Speakers = props => (
  <Container fluid className="speakers-container">
    <Container className="speakers-container">
      <h2 className="speakers-container-title">
        Relatori
      </h2>
      <Grid centered>
        {speakersList.map(speaker => (
          <Grid.Column computer={6} tablet={16} mobile={16} className="speaker-container">
            <div style={{ minWidth: 112 }}>
              <img src={speaker.image} style={{maxWidth: "100%"}} />
            </div>
            <div className="titles">
              <div className="speaker-title">
                {speaker.title}
              </div>
              <div className="speaker-subtitle" dangerouslySetInnerHTML={{__html: speaker.subtitle}}>
              </div>
            </div>
          </Grid.Column>
        ))}
      </Grid>
    </Container>
  </Container>
  )
  
export default Speakers;